import { render, staticRenderFns } from "./onChainRegistrationStatus.vue?vue&type=template&id=47578e20"
import script from "./onChainRegistrationStatus.vue?vue&type=script&lang=js"
export * from "./onChainRegistrationStatus.vue?vue&type=script&lang=js"
import style0 from "./onChainRegistrationStatus.vue?vue&type=style&index=0&id=47578e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports